<app-page-title [title]="'common.title.admin-console' | translateSafe"
                iconName="admin_panel_settings"
                class="red" />

<div class="super-console-content">
  <app-super-console-navigation />

  <router-outlet />
</div>
